import type Task from '../../entities/task';

/**
 * A task's time with its labor and travel time overrides applied: the labor time override when
 * labor time is overridden, else the elapsed time, plus the travel time override when travel
 * time is overridden. TaskHelper.getElapsedTime returns this, and the decimal-hours display
 * formats it (OWA-1766).
 *
 * @param {Task} task
 * @returns {number} milliseconds
 */
export function getTaskTime(task: Task): number {
    const laborTime = task.isLaborTimeOverridden ? task.laborTimeOverride : task.elapsedTime;
    const travelTime = task.isTravelTimeOverridden ? task.travelTimeOverride : 0;

    return (laborTime || 0.0) + (travelTime || 0.0);
}
